var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{on:{"click":_vm.acted}},[_c('router-view'),_c('wait-overlay',{attrs:{"state":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }